import axios, { AxiosResponse } from "axios";

/**
 * Обновление тоукена авторизации
 */
export const refreshToken = (): Promise<AxiosResponse<void>> => {
    return axios.post<void>('/site/default/master/isna-portal-cms/_/service/isnareactcms/user', {
        action: 'refresh_token',
    });
};
